import { cva } from "class-variance-authority";

/**
 * Certification Badges section styles
 */
export const baseCertificationBadgesStyles = [
  'flex',
  'flex-col',
  'gap-5',
  'w-full',
].join(' ');

export const certificationBadgesVariants = cva(baseCertificationBadgesStyles, {
  variants: {},
  defaultVariants: {},
});
